import React from "react";

export default function ReviewIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          fill="currentColor"
          d="m8.031 7.76 3.276-6.49A.774.774 0 0 1 12 .832c.274 0 .549.146.697.438l3.277 6.49 7.346 1.045a.806.806 0 0 1 .68.757.82.82 0 0 1-.255.668l-5.285 5.034 1.245 7.095c.118.664-.54 1.184-1.118.887L12 19.864l-6.584 3.384a.776.776 0 0 1-.219.075c-.513.09-1.002-.381-.9-.963l1.245-7.096L.26 10.23a.825.825 0 0 1-.258-.604.87.87 0 0 1 .128-.453.77.77 0 0 1 .555-.367L8.031 7.76ZM12 18.124a.75.75 0 0 1 .348.083l5.529 2.841-1.041-5.935a.847.847 0 0 1 .243-.758l4.36-4.154-6.078-.864a.788.788 0 0 1-.589-.432l-2.77-5.487L12 3.42v14.702Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .082h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
